<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div>
			<h5>注:忽略后，只需要把对应单据重新编辑一下即可!</h5>
		</div>
		<div>
			<div class="inline-bx">
				<h5>即将到期(30天)</h5>
				<table class="dataintable">
					<tr class="tab_header">
						<td>序号</td>
						<td>业务单号</td>
						<td class="short0">姓名</td>
						<td class="short0">电话</td>
						<td class="short0">车牌</td>
						<td class="short0">费用/年</td>
						<td class="short0">挂靠公司</td>
						<td class="short0">未付</td>
						<td class="short0">开始日期</td>
						<td class="short0">截止日期</td>
						<td class="short0">剩余天数</td>
						<td class="long1">备注</td>
						<td>操作</td>
					</tr>
					<tr v-for="(item, index) in list_vz_show" :key="index">
						<td>{{ item.row_num }}</td>
						<td>{{ item.sheet_no }}</td>
						<td class="short0">{{ item.u_name }}</td>
						<td class="short0">{{ item.u_phone }}</td>
						<td class="short0">{{ item.car_no }}</td>
						<td class="short0">{{ item.amount }}</td>
						<td class="short0">{{ item.c_name }}</td>
						<td class="short0">{{ item.amount_no }}</td>
						<td class="short0">{{ item.s_date }}</td>
						<td class="short0">{{ item.e_date }}</td>						
						<td class="short0">{{ item.lastday }}</td>
						<td class="long1" v-on:mousemove="show_detaildata($event, item.note, '1')"
							v-on:mouseout="noshow_detaildata">{{ item.note }}</td>
							
						<td><span class="hulue-btn" @click="fun_isNot(item)">忽略</span></td>
					</tr>
				</table>

				<!-- 分页部分 -->
				<div class="pre_page">
					<ul style="text-align: right; margin-right: 20px;">

						<li style="line-height: 24px;height: 24px;padding: 2px 6px;">
							<span>分页:
								<input class="short-word-1" style="line-height: 24px;height: 24px;width: 48px;"
									type="text" v-model="page_length"
									@change="refresh_data('PAGE_LENGTH_CHANGE')" /></span>

							当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp;

							<a href="#" @click="beforepage">上一页</a>|
							<a href="#" @click="nextpage">下一页</a>

						</li>
					</ul>
				</div>

			</div>
		</div>

		<div id="pre_msg_data" style="display:none;"></div>
	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Sel_page_and_length,
		Method_EasyAdd
	} from '@/utils/loadhttpdata.js';

	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";

	export default {
		name: "baoxian",
		data() {
			return {
				element_loading: false,

				list_vz: [],
				list_vz_show: [],


				show_bx: false,
				show_sc: false,
				show_by: false,

				maxpage: '',
				nowpage: 1,
				page_length: 20, //add 2022-01-25 默认分页长度
				all_count: 0,
				jumppage: '',

				maxpage2: '',
				nowpage2: 1,
				page_length2: 20, //add 2022-01-25 默认分页长度
				all_count2: 0,
				jumppage2: '',

			};
		},
		// created: function() {
		//   this.loaddata();
		// },
		mounted: function() {
			// console.log('保险 组件 mounted');
			this.loaddata();
		},
		// activated: function() {
		//   // console.log('保险 组件激活时调用 激活');
		//   this.loaddata();
		// },
		methods: {
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data('PAGE_LENGTH_CHANGE');
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			refresh_data: function() {
				this.maxpage = Math.floor(this.list_vz.length / this.page_length) + 1;
				let count = 0
				this.list_vz_show = [];
				let start_index = 0;
				start_index = (this.nowpage - 1) * this.page_length;

				for (let i = start_index; i < this.list_vz.length; i++) {
					if (count >= this.page_length) {
						break;
					}
					this.list_vz[i].row_num = i + 1;
					this.list_vz_show.push(this.list_vz[i]);
					count++;
				}
			},
			loaddata: function() {
				// console.log('加载数据')
				this.element_loading = true;
				this.list_vz = [];

				this.$post(
					api.http_method, Sel_page_and_length('exp_cargua_tx', this.nowpage, this.page_length)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.length > 0) {
						this.list_vz = res[0];
						console.log(this.list_vz);
						this.refresh_data();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			fun_isNot: function(item) {
				this.element_loading = true;

				this.$post(
					api.http_method, Method_EasyAdd('data_exp_cargua', item.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: item.car_no + ':' + res.data.msg,
							type: 'success'
						});

						this.loaddata();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.clientX - 100;
				y = that.clientY - 70;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			}
		}


	}
</script>

<style scoped="scoped">
	.inline-bx,
	.inline-by,
	.inline-sc {
		display: inline-block;
		min-height: calc(100vh - 150px);
		max-height: calc(100vh - 150px);
		overflow: auto;
		vertical-align: top;
	}

	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.hulue-btn {
		display: inline-block;
		/* border: 1px solid black; */
		border-radius: 5px;
		background: #ff5500;
		text-align: center;
		padding: 2px 2px 2px 2px;
		/* font-size: 16px; */
		margin-left: 2px;
		margin-right: 2px;
		color: #fff;
	}

	.hulue-btn:hover {
		cursor: pointer;
		background-color: rgba(247, 61, 36, 0.986);
		/* font-size: 16px; */
		background: #dedede;
		color: #000000;
	}
</style>
